module.exports = __webpack_public_path__ + "static/img/__2051.27c2f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__2051.jpg
// module id = qa9U
// module chunks = 0